export default {
  'Teklif Formu': '견적 양식',
  'Kayıtlı Teklifler': '저장된 견적',
  'Kullanıcı Adı': '사용자 이름',
  'Şifre': '비밀번호',
  'Giriş Yap': '로그인',
  'Çıkış Yap': '로그아웃',
  'KDV Oranı': '부가세율',
  'Teklif Durumu': '견적 상태',
  'Kaydet': '저장',
  'PDF Önizleme': 'PDF 미리보기',
  'PDF\'ye Aktar': 'PDF로 내보내기',
  'E-posta ile Gönder': '이메일로 보내기',
  'Alıcı': '수신자',
  'Tarih': '날짜',
  'Genel Toplam': '총합계',
  'Not': '메모',
  'KDV': '부가세',
  'Alt Toplam': '소계',
  'Açıklama': '설명',
  'Ürün Adı': '제품명',
  'SUT Kodu': 'SUT 코드',
  'Birim Alış Fiyatı': '단위 가격',
  'Sipariş Adedi': '주문 수량',
  'Promosyon Ürün': '프로모션 제품',
  'Toplam Adet': '총 수량',
  'Sipariş Tutarı': '주문 금액',
  'Durum': '상태',
  'Kabul Edildi': '승인됨',
  'Reddedildi': '거부됨',
  'Gönderildi': '전송됨',
  'Taslak': '초안',
  'Yurtiçi': '국내',
  'Yurtdışı': '해외',
  'Sipariş Oluştur': '주문 생성',
  'Ürün Sıralaması': '제품 정렬',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': '제품은 인기도와 중요도 수준에 따라 정렬됩니다',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': '심장학 및 혈관외과 제품이 우선적으로 표시됩니다',
  'Ürün adı, açıklama veya barkod ile ara...': '제품명, 설명 또는 바코드로 검색...',
  'Tüm Kategoriler': '모든 카테고리',
  'Kutu görünüm': '그리드 보기',
  'Liste görünüm': '목록 보기',
  'Aradığınız kriterlere uygun ürün bulunamadı': '검색 조건에 맞는 제품을 찾을 수 없습니다',
  'Ürün Adı Yok': '제품명 없음',
  'Kategori Yok': '카테고리 없음',
  'Açıklama yok': '설명 없음',
  'Firma Bilgilerini Doldurun': '회사 정보 입력',
  'Sepete Ekle': '장바구니에 추가',
  'Firma Bilgileri': '회사 정보',
  'Ülke Seçimi': '국가 선택',
  'Türkiye': '터키',
  'Almanya': '독일',
  'ABD': '미국',
  'Firma Ünvanı': '회사명',
  'Vergi Dairesi': '세무서',
  'Vergi Numarası': '사업자등록번호',
  'Adres': '주소',
  'Şehir': '도시',
  'Şehir Seçimi': '도시 선택',
  'Şehir adı ara...': '도시명 검색...',
  'Aradığınız şehir bulunamadı': '도시를 찾을 수 없습니다',
  'Bu ülke için şehir verisi bulunamadı': '이 국가에 대한 도시 데이터가 없습니다',
  'şehir bulundu': '{{count}}개 도시를 찾았습니다',
  'Yetkili': '담당자',
  'Telefon': '전화',
  'Email': '이메일',
  'Bilgileri İlet': '정보 전송',
  'Lütfen eksik alanları doldurun': '빈 필드를 채워주세요',
  'Firma kaydedilemedi': '회사를 저장할 수 없습니다',
  'Firma bilgileri başarıyla iletildi': '회사 정보가 성공적으로 전송되었습니다',
  'Firma Ünvanı:': '회사명:',
  'Yetkili Kişi:': '담당자:',
  'Sepetiniz': '장바구니',
  'Sepetiniz boş': '장바구니가 비어있습니다',
  'adet': '개',
  'Düzenle': '편집',
  'Kaldır': '제거',
  'Siparişi Tamamla': '주문 완료',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': '먼저 완전한 회사 정보를 전송해주세요',
  'Sipariş başarıyla kaydedildi': '주문이 성공적으로 저장되었습니다',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': '환영 메시지와 접속 링크가 이메일로 전송되었습니다',
  'Link 3 gün geçerlidir': '링크는 3일간 유효합니다',
  'Sipariş kaydedilemedi': '주문을 저장할 수 없습니다',
  'Firma Bilgileri Gerekli': '회사 정보 필요',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': '장바구니에 추가하려면 먼저 회사 정보를 입력하세요',
  'Önce Bilgileri Doldurun': '먼저 정보 입력',
  'Uyarı': '경고',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': '장바구니에 추가하려면 먼저 회사 정보를 입력해야 합니다',
  'SUT Kütüphanesi Tanımı': 'SUT 라이브러리 정의',
  'SUT Kodu:': 'SUT 코드:',
  'Standart': '표준',
  'Açıklama (isteğe bağlı)': '설명 (선택사항)',
  'Partner Ol': '파트너 되기',
  'Partner başvuru popup açılacak': '파트너 신청 팝업이 열립니다',
  'Dil': '언어',
  'E-posta': '이메일',
  'globalPartnersTitle': '전 세계 30,000개 파트너와의 협력',
  'globalPartnersDesc': '30,000개 파트너로 구성된 우리의 광범위한 글로벌 네트워크는 공동 혁신, 지식 공유 및 상호 성공을 촉진합니다. 함께 우리는 환자 치료의 경계를 지속적으로 확장하고 있습니다.',
  'bayiBasvuru': 'INVAMED 파트너 신청 양식',
  'bayiBasvuruDesc': 'INVAMED 파트너 네트워크에 가입하려면 아래 양식을 작성하세요. 신청서 검토 후 연락드리겠습니다.',
  'applyFields': {
    'firma': '회사명',
    'vergiNo': '세무서 / 사업자등록번호',
    'yetkili': '담당자 전체 이름',
    'telefon': '전화',
    'email': '이메일',
    'adres': '주소',
    'sektor': '업종 / 섹터',
    'sicil': '상업등록번호',
    'web': '웹사이트'
  },
  'Şifremi Unuttum': '비밀번호 찾기',
  'Demo Giriş': '데모 로그인',
  'Bayi Başvurusu': '파트너 신청',
  'Yardım': '도움말',
  'Giriş yapılıyor...': '로그인 중...',
  'E-posta veya şifre hatalı': '잘못된 이메일 또는 비밀번호',
  'Şifre sıfırlama e-postası gönderildi': '비밀번호 재설정 이메일이 전송되었습니다',
  'E-posta gönderilemedi': '이메일을 전송할 수 없습니다',
  'Vergi Dairesi / Vergi No': '세무서 / 사업자등록번호',
  'Yetkili Adı Soyadı': '담당자 전체 이름',
  'Faaliyet Alanı / Sektör': '업종 / 섹터',
  'Ticaret Sicil No': '상업등록번호',
  'Web Sitesi': '웹사이트',
  'Temel Bilgiler': '기본 정보',
  'Ek Bilgiler': '추가 정보',
  'Başvuru Gönder': '신청서 전송',
  'Başvuru gönderiliyor...': '신청서 전송 중...',
  'Başvuru başarıyla gönderildi': '신청서가 성공적으로 전송되었습니다',
  'Başvuru gönderilemedi': '신청서를 전송할 수 없습니다',
  'Sözleşme şartlarını kabul ediyorum': '계약 조건을 수락합니다',
  'Dosya Yükle': '파일 업로드',
  'Dosya seçilmedi': '파일이 선택되지 않았습니다',
  'Dosya yüklendi': '파일이 성공적으로 업로드되었습니다',
  'Dosya yüklenemedi': '파일을 업로드할 수 없습니다',
  'Tamamla': '완료',
  'Geri': '뒤로',
  'İleri': '다음',
  'Kapat': '닫기',
  'Yardım İçeriği': '도움말 내용',
  'dil': '언어',
  'Üye Ol': '회원가입',
  'Üye Değil Misiniz?': '회원이 아니신가요?',
  'Şimdi Üye Ol': '지금 회원가입',
  'Misafir Kullanıcı': '게스트 사용자',
  'Hızlı Sipariş': '빠른 주문',
  'Misafir Olarak Sipariş Verin': '게스트로 주문하기',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': '로그인 없이 빠르게 제품을 선택하고 주문을 생성하세요',
  'Giriş yapmadan sipariş oluşturun': '로그인 없이 주문 생성',
  'Anında Erişim': '즉시 접근',
  'Tüm ürünlere anında erişim': '모든 제품에 즉시 접근',
  'Güvenli İşlem': '안전한 거래',
  'SSL korumalı güvenli sipariş': 'SSL 보호 안전 주문',
  'Misafir Olarak Sipariş Oluştur': '게스트로 주문 생성',
  'İpucu:': '팁:',
  'Daha fazla özellik için üye olun': '더 많은 기능을 위해 회원가입하세요',
  'Ücretsiz': '무료',
  'Hızlı': '빠름',
  'Güvenli': '안전',
  'bayilikSozlesme': '파트너십 조건과 계약을 읽고 수락했습니다.',
  'geri': '뒤로',
  'basvuruGonder': '신청서 전송',
  'ileri': '다음',
  'sozlesmeGonderildi': '계약이 이메일로 전송되었습니다!',
  'sozlesmeDesc': '이메일로 전송된 INVAMED 파트너십 계약과 필요한 문서를 업로드해주세요.',
  'tamamla': '신청서 완료',
  'basvuruAlindi': '신청서가 접수되었습니다!',
  'basvuruAlindiDesc': 'INVAMED 팀이 신청서를 검토하고 최대한 빨리 연락드리겠습니다.',
  'Başvuru Durumu': '신청 상태',
  'Başvurunuz onay sürecindedir': '귀하의 신청이 검토 중입니다',
  'sifreSifirla': '비밀번호 재설정',
  'sifreSifirlaDesc': '등록된 이메일을 입력하시면 비밀번호 재설정 지침을 보내드립니다.',
  'gonder': '전송',
  'talimatGonderildi': '지침 전송됨',
  'sentDesc': '비밀번호 재설정 지침이 <b>{email}</b>로 전송되었습니다. 이메일을 확인해주세요.',
  'helpTitle': '어떻게 로그인할 수 있나요?',
  'helpList': [
    'INVAMED 파트너 패널에 로그인하려면 등록된 이메일과 비밀번호를 입력하세요.',
    '데모 사용자로 로그인하려면:',
    '비밀번호를 잊으셨다면 "비밀번호 찾기" 링크를 통해 재설정을 요청할 수 있습니다.',
    '로그인에 문제가 있다면 올바른 이메일과 비밀번호를 입력했는지 확인하세요. 문제가 지속되면 지원팀에 문의하세요.'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED 파트너십 계약 및 조건',
  'partnerlikSozlesmeText': `1. 일반 조항

이 계약은 INVAMED(이하 "회사")와 파트너 후보자(이하 "파트너") 간에 의료 장비 및 액세서리 판매를 위한 협력을 위해 체결됩니다.

2. 파트너십 조건

2.1. 파트너는 의료 장비 판매에 대한 법적 권한을 가져야 합니다.
2.2. 파트너는 의료 서비스 분야에서 활동하는 조직이어야 합니다.
2.3. 파트너는 필요한 라이센스와 인증서를 보유해야 합니다.
2.4. 파트너는 재정적으로 신뢰할 수 있어야 합니다.

3. 당사자의 의무

회사의 의무:
3.1. 고품질 제품 및 서비스 제공
3.2. 기술 지원 제공
3.3. 교육 및 정보 제공
3.4. 가격 책정에서 투명성

파트너의 의무:
3.1. 적절한 조건에서 제품 보관
3.2. 고품질 고객 서비스 제공
3.3. 법적 규정 준수
3.4. 회사 브랜드 보호

4. 가격 책정 및 지불

4.1. 가격은 회사에 의해 결정됩니다
4.2. 파트너는 결정된 가격을 준수할 의무가 있습니다
4.3. 지불 조건은 별도로 결정됩니다
4.4. 수수료율은 성과에 따라 달라질 수 있습니다

5. 기밀성 및 보안

5.1. 당사자는 서로의 기밀 정보를 보호할 의무가 있습니다
5.2. 고객 정보는 기밀로 유지되어야 합니다
5.3. 데이터 보안 표준을 준수해야 합니다

6. 계약 기간 및 해지

6.1. 이 계약은 1년간 유효합니다
6.2. 상호 동의에 따라 연장될 수 있습니다
6.3. 30일 전 통지로 해지될 수 있습니다
6.4. 심각한 위반 시 즉시 해지될 수 있습니다

7. 분쟁 해결

7.1. 분쟁은 먼저 협상을 통해 해결하려고 시도합니다
7.2. 해결할 수 없는 경우 터키 공화국 법원이 관할권을 가집니다

8. 발효

이 계약은 당사자에 의해 읽히고, 이해되고, 수락되었습니다. 나는 이 계약의 모든 조항을 수락하고 의무를 이행할 것임을 선언합니다.`,
  'partnerlikSozlesmeOnay': '위의 INVAMED 파트너십 계약 및 조건을 읽고, 이해하고, 수락했습니다. 나는 이 계약의 모든 조항을 수락하고 의무를 이행할 것임을 선언합니다.',
  'sozlesmeyiGoruntule': '계약 보기',
  'sozlesmeyiKapat': '닫기',
  'Ürün': '제품',
  'Ürün eklemek için ürün listesinden seçim yapın': '제품을 추가하려면 제품 목록에서 선택하세요',
  'Etiketler': '태그',
  'Öncelikli': '우선순위',
  'Ülke Seçiniz': '국가 선택',
  'Firma / Sağlık Profesyoneli': '회사 / 의료 전문가',
  'Şehir Seçiniz': '도시 선택',
  'Yetkili Kişi': '담당자',
  'UDI Kodu': 'UDI 코드',
  'Teklif başarıyla kaydedildi!': '견적이 성공적으로 저장되었습니다!',
  'Aynı teklif zaten kayıtlı!': '동일한 견적이 이미 저장되어 있습니다!',
  'Kullanıcı adı veya şifre hatalı!': '잘못된 사용자 이름 또는 비밀번호!',
  'Teklif No': '견적 번호',
  'Teklifler': '견적',
  'Yedeklenecek teklif yok!': '백업할 견적이 없습니다!',
  'Yedek dosyası indirildi.': '백업 파일이 다운로드되었습니다.',
  'Yedek başarıyla yüklendi.': '백업이 성공적으로 로드되었습니다.',
  'Geçersiz veya bozuk dosya!': '잘못되었거나 손상된 파일!',
  'Yedekle (JSON)': '백업 (JSON)',
  'Geri Yükle': '복원',
  'Kayıtlı teklif yok.': '저장된 견적이 없습니다.',
  'E-posta Durumu': '이메일 상태',
  'İşlemler': '거래',
  'E-posta ile gönderildi': '이메일로 전송됨',
  'E-posta gönderilmedi': '이메일이 전송되지 않음',
  'Görüntüle': '보기',
  'Sil': '삭제',
  'Gönderildi': '전송됨',
  'Gönderilmedi': '전송되지 않음',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': '견적 ID를 찾을 수 없습니다! 다시 시도해주세요.',
  'Lütfen partner seçiniz.': '파트너를 선택해주세요.',
  'Lütfen teslimat tarihi belirtiniz.': '배송 날짜를 지정해주세요.',
  'Proforma başarıyla oluşturuldu!': '프로포마가 성공적으로 생성되었습니다!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': '프로포마가 생성되었지만 제품을 추가할 수 없습니다. 자세한 내용은 콘솔을 확인하세요.',
  'Link başarıyla silindi': '링크가 성공적으로 삭제되었습니다',
  'Link kopyalandı!': '링크가 복사되었습니다!',
  'Ödeme durumu başarıyla güncellendi!': '결제 상태가 성공적으로 업데이트되었습니다!',
  'dosyası okunamadı!': '파일을 읽을 수 없습니다!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': '모든 파일에 대해 SUT 코드와 가격 열을 선택해야 합니다!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': '로드할 유효한 행을 찾을 수 없습니다! 파일에 SUT 코드와 가격이 채워진 행이 있는지 확인하세요.',
  'Yükleme sırasında hata oluştu!': '로드 중 오류가 발생했습니다!',
  'Otomatik etiket ekleme başarısız!': '자동 태그 추가 실패!',
  'Etiketler başarıyla güncellendi!': '태그가 성공적으로 업데이트되었습니다!',
  'Etiketler güncellenirken hata oluştu!': '태그 업데이트 중 오류가 발생했습니다!',
  'Resim başarıyla yüklendi!': '이미지가 성공적으로 업로드되었습니다!',
  'Resim yüklendi ama ürün güncellenemedi!': '이미지가 업로드되었지만 제품을 업데이트할 수 없습니다!',
  'Resim yüklenirken hata oluştu!': '이미지 업로드 중 오류가 발생했습니다!',
  'Ürün başarıyla güncellendi!': '제품이 성공적으로 업데이트되었습니다!',
  'Ürün güncellenirken hata oluştu!': '제품 업데이트 중 오류가 발생했습니다!',
  'Hata:': '오류:',
  'Güncelleme hatası:': '업데이트 오류:',
  'Alanlar yüklendi:': '필드 로드됨:',
  'alan': '필드',
  'Connect Free!': '무료로 연결하세요!',
  'En çok tercih edilen ürünlerimizi keşfedin': '우리의 가장 인기 있는 제품을 발견하세요',
  'Tüm Kategoriler': '모든 카테고리',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48개 제품 표시 (총: 8000+)',
  'Tüm Ürünleri Gör →': '모든 제품 보기 →',
  'Detaylar': '세부사항',
  'Sipariş Ver': '지금 주문',
  'Giriş Yap': '로그인',
  'Hesabınıza giriş yapın': '계정에 로그인하세요',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': '이 사이트는 reCAPTCHA로 보호되며 Google 개인정보처리방침 및 서비스 약관이 적용됩니다.',
  'Ürün Kataloğumuz': '우리의 제품 카탈로그',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': '8000개 이상의 제품을 제공합니다',
  '1,3B': '1.3천',
  'Partner': '파트너',
  '8,4M': '840만',
  'Toplam Üretim': '총 생산량',
  '23': '23',
  'Branş': '지점',
  '27,5B': '27.5천',
  'Toplam Sipariş': '총 주문',
  'Connect Now': '지금 연결',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': '모든 정보에 한 곳에서 접근할 수 있도록 무료로 가입하세요.',
  'Ürün Detayları': '제품 상세정보',
  'Kapat': '닫기',
  'Yükleniyor...': '로딩 중...',
  'Hata': '오류',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}}개 제품 표시 (총: 8000+)',
  'Şehir Seçimi': '도시 선택',
  'Firma / Sağlık Profesyoneli': '회사 / 의료 전문가',
  'Yetkili Kişi': '권한자',
  'Telefon': '전화',
  'E-posta': '이메일',
  'E-Posta': '이메일',
  'Temel Bilgiler': '기본 정보',
  'Ek Bilgiler': '추가 정보',
  'Faaliyet Alanı / Sektör': '활동 영역 / 섹터',
  'Ülke Seçimi': '국가 선택',
  'Ülke adı veya kodu ara...': '국가명 또는 코드 검색...',
  'region.Avrupa': '유럽',
  'region.Amerika': '아메리카',
  'region.Asya': '아시아',
  'region.Afrika': '아프리카',
  'region.Okyanusya': '오세아니아',
  'region.Diğer': '기타',
  'country.TR': '터키',
  'country.US': '미국',
  'country.DE': '독일',
  'country.FR': '프랑스',
  'country.GB': '영국',
  'country.IT': '이탈리아',
  'country.ES': '스페인',
  'country.RU': '러시아',
  'country.CN': '중국',
  'country.JP': '일본',
  'country.KR': '대한민국',
  'country.IN': '인도',
  'country.BR': '브라질',
  'country.CA': '캐나다',
  'country.AU': '호주',
  'Ticaret Sicil No': '상업 등기 번호',

  'country.TR': '터키',
  'country.AL': '알바니아',
  'country.DE': '독일',
  'country.AD': '안도라',
  'country.AT': '오스트리아',
  'country.BY': '벨라루스',
  'country.BE': '벨기에',
  'country.BA': '보스니아 헤르체고비나',
  'country.BG': '불가리아',
  'country.CZ': '체코 공화국',
  'country.DK': '덴마크',
  'country.EE': '에스토니아',
  'country.FO': '페로 제도',
  'country.FI': '핀란드',
  'country.FR': '프랑스',
  'country.GI': '지브롤터',
  'country.GR': '그리스',
  'country.GG': '건지',
  'country.HR': '크로아티아',
  'country.NL': '네덜란드',
  'country.IE': '아일랜드',
  'country.ES': '스페인',
  'country.SE': '스웨덴',
  'country.CH': '스위스',
  'country.IT': '이탈리아',
  'country.IS': '아이슬란드',
  'country.JE': '저지',
  'country.ME': '몬테네그로',
  'country.LV': '라트비아',
  'country.LI': '리히텐슈타인',
  'country.LT': '리투아니아',
  'country.LU': '룩셈부르크',
  'country.HU': '헝가리',
  'country.MT': '몰타',
  'country.IM': '맨 섬',
  'country.MD': '몰도바',
  'country.MC': '모나코',
  'country.MK': '북마케도니아',
  'country.NO': '노르웨이',
  'country.PL': '폴란드',
  'country.PT': '포르투갈',
  'country.RO': '루마니아',
  'country.RU': '러시아',
  'country.SM': '산마리노',
  'country.RS': '세르비아',
  'country.SK': '슬로바키아',
  'country.SI': '슬로베니아',
  'country.SJ': '스발바르 얀마옌',
  'country.UA': '우크라이나',
  'country.GB': '영국',
  'country.VA': '바티칸',
  'country.AX': '올란드 제도',
  'country.US': '미국',
  'country.AS': '미국령 사모아',
  'country.AI': '앵귈라',
  'country.AG': '앤티가 바부다',
  'country.AR': '아르헨티나',
  'country.AW': '아루바',
  'country.BS': '바하마',
  'country.BB': '바베이도스',
  'country.BZ': '벨리즈',
  'country.BM': '버뮤다',
  'country.BO': '볼리비아',
  'country.BR': '브라질',
  'country.VG': '영국령 버진아일랜드',
  'country.CA': '캐나다',
  'country.KY': '케이맨 제도',
  'country.CL': '칠레',
  'country.CO': '콜롬비아',
  'country.CR': '코스타리카',
  'country.CU': '쿠바',
  'country.CW': '퀴라소',
  'country.DM': '도미니카',
  'country.DO': '도미니카 공화국',
  'country.EC': '에콰도르',
  'country.SV': '엘살바도르',
  'country.FK': '포클랜드 제도',
  'country.GF': '프랑스령 기아나',
  'country.GD': '그레나다',
  'country.GL': '그린란드',
  'country.GP': '과들루프',
  'country.GT': '과테말라',
  'country.GY': '가이아나',
  'country.HT': '아이티',
  'country.HN': '온두라스',
  'country.JM': '자메이카',
  'country.MQ': '마르티니크',
  'country.MX': '멕시코',
  'country.MS': '몬트세랫',
  'country.NI': '니카라과',
  'country.PA': '파나마',
  'country.PY': '파라과이',
  'country.PE': '페루',
  'country.PR': '푸에르토리코',
  'country.BL': '생바르텔레미',
  'country.KN': '세인트키츠 네비스',
  'country.LC': '세인트루시아',
  'country.MF': '생마르탱',
  'country.PM': '생피에르 미클롱',
  'country.VC': '세인트빈센트 그레나딘',
  'country.SX': '신트마르턴',
  'country.SR': '수리남',
  'country.TT': '트리니다드 토바고',
  'country.TC': '터크스 케이커스 제도',
  'country.UY': '우루과이',
  'country.VE': '베네수엘라',
  'country.VI': '미국령 버진아일랜드',
  'country.AF': '아프가니스탄',
  'country.AZ': '아제르바이잔',
  'country.BH': '바레인',
  'country.BD': '방글라데시',
  'country.AE': '아랍에미리트',
  'country.BN': '브루나이',
  'country.BT': '부탄',
  'country.CN': '중국',
  'country.TL': '동티모르',
  'country.ID': '인도네시아',
  'country.AM': '아르메니아',
  'country.PH': '필리핀',
  'country.PS': '팔레스타인',
  'country.GE': '조지아',
  'country.KR': '대한민국',
  'country.IN': '인도',
  'country.HK': '홍콩',
  'country.IQ': '이라크',
  'country.IR': '이란',
  'country.IL': '이스라엘',
  'country.JP': '일본',
  'country.KH': '캄보디아',
  'country.QA': '카타르',
  'country.KZ': '카자흐스탄',
  'country.KG': '키르기스스탄',
  'country.CY': '키프로스',
  'country.KW': '쿠웨이트',
  'country.KP': '북한',
  'country.LA': '라오스',
  'country.LB': '레바논',
  'country.MO': '마카오',
  'country.MV': '몰디브',
  'country.MY': '말레이시아',
  'country.MM': '미얀마',
  'country.MN': '몽골',
  'country.NP': '네팔',
  'country.UZ': '우즈베키스탄',
  'country.PK': '파키스탄',
  'country.SG': '싱가포르',
  'country.LK': '스리랑카',
  'country.SY': '시리아',
  'country.SA': '사우디아라비아',
  'country.TJ': '타지키스탄',
  'country.TH': '태국',
  'country.TW': '대만',
  'country.TM': '투르크메니스탄',
  'country.OM': '오만',
  'country.JO': '요르단',
  'country.VN': '베트남',
  'country.YE': '예멘',
  'country.DZ': '알제리',
  'country.AO': '앙골라',
  'country.BJ': '베냉',
  'country.BW': '보츠와나',
  'country.BF': '부르키나파소',
  'country.BI': '부룬디',
  'country.CV': '카보베르데',
  'country.CM': '카메룬',
  'country.CF': '중앙아프리카공화국',
  'country.TD': '차드',
  'country.KM': '코모로',
  'country.CG': '콩고 공화국',
  'country.CD': '콩고 민주공화국',
  'country.CI': '코트디부아르',
  'country.DJ': '지부티',
  'country.EG': '이집트',
  'country.GQ': '적도기니',
  'country.ER': '에리트레아',
  'country.SZ': '에스와티니',
  'country.ET': '에티오피아',
  'country.GA': '가봉',
  'country.GM': '감비아',
  'country.GH': '가나',
  'country.GN': '기니',
  'country.GW': '기니비사우',
  'country.KE': '케냐',
  'country.LS': '레소토',
  'country.LR': '라이베리아',
  'country.LY': '리비아',
  'country.MG': '마다가스카르',
  'country.MW': '말라위',
  'country.ML': '말리',
  'country.MR': '모리타니',
  'country.MU': '모리셔스',
  'country.YT': '마요트',
  'country.MA': '모로코',
  'country.MZ': '모잠비크',
  'country.NA': '나미비아',
  'country.NE': '니제르',
  'country.NG': '나이지리아',
  'country.RE': '레위니옹',
  'country.RW': '르완다',
  'country.SH': '세인트헬레나',
  'country.ST': '상투메프린시페',
  'country.SN': '세네갈',
  'country.SC': '세이셸',
  'country.SL': '시에라리온',
  'country.SO': '소말리아',
  'country.ZA': '남아프리카공화국',
  'country.SS': '남수단',
  'country.SD': '수단',
  'country.TZ': '탄자니아',
  'country.TG': '토고',
  'country.TN': '튀니지',
  'country.UG': '우간다',
  'country.EH': '서사하라',
  'country.ZM': '잠비아',
  'country.ZW': '짐바브웨',
  'country.AU': '오스트레일리아',
  'country.CX': '크리스마스섬',
  'country.CC': '코코스제도',
  'country.CK': '쿡제도',
  'country.FJ': '피지',
  'country.PF': '프랑스령 폴리네시아',
  'country.GU': '괌',
  'country.HM': '허드맥도널드제도',
  'country.KI': '키리바시',
  'country.MH': '마셜제도',
  'country.FM': '미크로네시아',
  'country.NR': '나우루',
  'country.NC': '뉴칼레도니아',
  'country.NZ': '뉴질랜드',
  'country.NU': '니우에',
  'country.NF': '노퍽섬',
  'country.MP': '북마리아나제도',
  'country.PW': '팔라우',
  'country.PG': '파푸아뉴기니',
  'country.PN': '핏케언제도',
  'country.WS': '사모아',
  'country.SB': '솔로몬제도',
  'country.TK': '토켈라우',
  'country.TO': '통가',
  'country.TV': '투발루',
  'country.VU': '바누아투',
  'country.WF': '왈리스푸투나',
  'country.AQ': '남극',
  'country.BV': '부베섬',
  'country.IO': '영국령 인도양 지역',
  'country.TF': '프랑스령 남부지역',
  'country.GS': '사우스조지아 사우스샌드위치제도',
};
